import React, { useState, useEffect } from 'react';
import "./HelpPost.css";
import { Avatar } from "@material-ui/core";
import { db } from "../firebase";
import firebase from "firebase";

function HelpPost({ helpId, displayName, photoURL, question, user }) {
    const [answer, setAnswer] = useState("");
    const [answers, setAnswers] = useState([]);

    const postAnswer = (e) => {
        e.preventDefault();
        if (answer === "") {
            alert("Please input your answer before posting.")
        } else {
            db.collection("help").doc(helpId).collection("answers").add({
                username: user?.displayName,
                uid: user?.uid,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                answer
            })
            setAnswer("");
            console.log("An answer to "+question+" has been posted succesfully.")
        }
    }

    useEffect(() => {
        let unsubscribe;
        if (helpId) {
            unsubscribe = db
            .collection("help")
            .doc(helpId)
            .collection("answers")
            .orderBy('timestamp', 'desc')
            .onSnapshot((snapshot) => {
                setAnswers(snapshot.docs.map((docs) => docs.data()));
            });
        }

        return () => {
            unsubscribe();
        };
    }, [helpId])
 
    return (
        <center>
        <div className="helpPost">
            <div className="sendersInfo">
                <Avatar src={photoURL} />
                <h4>{displayName}</h4>
            </div>
            <div className="question">
                <p>{question}</p>
            </div>
            <div className="help_answers_input">
                <input placeholder="Have a answer to this question?" value={answer} onChange={(e) => setAnswer(e.target.value)}/>
                <button onClick={postAnswer}>POST</button>
            </div>
            <div className="help__answers">
            {answers.map((comment) => (
                <>
                    <strong>{comment.username}:</strong> <p>{comment.answer}</p>
                </>
        ))}
            </div>
        </div>
        </center>
    )
}

export default HelpPost;